"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FitLevelAI = void 0;
var FitLevelAI;
(function (FitLevelAI) {
    FitLevelAI["GOOD_MATCH"] = "Good Match";
    FitLevelAI["POTENTIAL_MATCH"] = "Potential Match";
    FitLevelAI["BETTER_OPTIONS_AVAILABLE"] = "Better Options Available";
})(FitLevelAI || (exports.FitLevelAI = FitLevelAI = {}));
